<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 6" width="18" height="18">
    <circle fill="white" cx="3" cy="3" r="3"/>
    <circle fill="white" cx="12" cy="3" r="3"/>
    <circle fill="white" cx="21" cy="3" r="3"/>
  </svg>
</template>

<script>
export default {
  name: "IconOtherAsset"
}
</script>

<style scoped>

</style>